module.exports = __webpack_public_path__ + "static/media/yosef-crown-white-fix.84f49e7a.png";